<template lang="pug">
    section#blockTextoCarrousel
        .container
            ul(ref="items", v-if="imagesBlock != undefined").items
                li(v-for="item, index in imagesBlock" :class="{'ativo': ativo == index}").item
                    Imagem(:content="item.image")
            img(:src="require('@images/filosofia.gif')").gif
            // ul(ref="items", v-if="imagesBlock != undefined").legendas
            //     li(v-for="item, index in imagesBlock" :class="{'ativo': ativo == index}").item
            //         SvgIcon(data="@svgs/circle-filosofia.svg").dashed
            //         SvgIcon(data="@svgs/circle-filosofia.svg").solid
            //         i
            //         p {{ item.legenda }}
        TextoSimples(:content="textBlock", v-if="textBlock != undefined")
</template>

<script>
import { components } from '@/mixins/components'
export default {
    name: "component-block-texto-carrousel",
    components,
    props: {
        content: {
            type: Array,
            required: true
        },
    },
    data() {
        return {
            ativo: null
        }
    },
    computed: {
        textBlock() {
            return this.content.find(block => block.type == 'textos_item')
        },
        imagesBlock() {
            return this.content.filter(block => block.type == 'galeriaImgTexto_item')
        },
    },
    mounted() {
        setTimeout(() => {
            this.ativo = 0
            this.autoloop()
        }, 500)
    },
    methods: {
        autoloop(){
            setInterval(() => {
                // console.log(this.ativo, this.imagesBlock.length - 1)
                if(this.ativo >= this.imagesBlock.length - 1)
                    this.ativo = 0
                else
                    this.ativo += 1
            }, 7350)
        }
    }
}
</script>

<style lang="stylus" scoped src="./BlockTextoCarrousel.styl"></style>